// extracted by mini-css-extract-plugin
export default {"box":"refundInitiationListPage_box__M7i43"};